import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "flex justify-between"
};
const _hoisted_2 = {
  class: "flex justify-between py-2"
};
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center w-11/12"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1,
  class: "w-11/12 flex justify-center"
};
const _hoisted_6 = {
  class: "flex flex-col"
};
const _hoisted_7 = {
  "data-cy": "company-name",
  class: "font-bold"
};
import { storeToRefs } from 'pinia';
import { useInvoiceTemplateStore } from '@/services/useInvoiceTemplateStore.js';
import { useInvoiceEmailStore } from '@/modules/settings/company/InvoiceEmail/useInvoiceEmailStore.js';
import { onMounted } from 'vue';

// Props
import { convertNewlinesToBreaks } from '@/services/utils';
import LlHtmlViewerIframe from '@/components/LlHtmlViewerIframe.vue';
export default {
  __name: 'InvoiceTableLogoAndHeader',
  props: {
    contactInformation: {
      type: String,
      required: false,
      default: null
    },
    companyName: {
      type: String,
      required: false,
      default: ''
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const {
      invoiceDelivery
    } = storeToRefs(useInvoiceEmailStore());
    const {
      invoiceInfo
    } = storeToRefs(useInvoiceTemplateStore());
    const {
      getInvoiceTemplateInfo
    } = useInvoiceTemplateStore();
    onMounted(async () => {
      await getInvoiceTemplateInfo();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("span", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_unref(invoiceDelivery).logoUrl ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
        src: `${props.leanLawAuth.domain}/v1/invoicedeliverysettings/logo`,
        class: "max-w-[250px] max-h-[187px] object-contain"
      }, null, 8, _hoisted_4)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [_createElementVNode("span", null, [_createElementVNode("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("path", {
        d: "M4.125 5.5V1.375H6.875V5.5H11V8.25H6.875V12.375H4.125V8.25H0V5.5H4.125ZM8.25 13.75V9.625H12.375V5.5H22L24.5163 8.25H28.875C30.3875 8.25 31.625 9.4875 31.625 11V27.5C31.625 29.0125 30.3875 30.25 28.875 30.25H6.875C5.3625 30.25 4.125 29.0125 4.125 27.5V13.75H8.25ZM17.875 26.125C21.67 26.125 24.75 23.045 24.75 19.25C24.75 15.455 21.67 12.375 17.875 12.375C14.08 12.375 11 15.455 11 19.25C11 23.045 14.08 26.125 17.875 26.125ZM13.475 19.25C13.475 21.6838 15.4412 23.65 17.875 23.65C20.3088 23.65 22.275 21.6838 22.275 19.25C22.275 16.8162 20.3088 14.85 17.875 14.85C15.4412 14.85 13.475 16.8162 13.475 19.25Z",
        fill: "#C4C4C4"
      })])], -1), _createElementVNode("span", {
        class: "px-2 py-3 text-xs"
      }, "LOGO", -1)]))]))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(__props.companyName || _unref(invoiceInfo)?.companyName), 1), _createVNode(LlHtmlViewerIframe, {
        htmlContent: _unref(convertNewlinesToBreaks)(__props.contactInformation || _unref(invoiceInfo)?.companyAddress)
      }, null, 8, ["htmlContent"])])]);
    };
  }
};